if ( typeof QuickLinks !== 'function' ) {

  class QuickLinks extends HTMLElement {

    constructor() {

      super();

      this.links = this.querySelectorAll('[data-link-scroll]');
      
      this.links?.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          const targetId = element.getAttribute('data-link-scroll');
          const target = document.querySelector(`[data-section-id="${targetId}"]`);

          if (!target) return;
          target.scrollIntoView({behavior: 'smooth', block: 'start'});
        });
      });
    }
  }

  if ( typeof customElements.get('quick-links') == 'undefined' ) {
    customElements.define('quick-links', QuickLinks);
	}

}